import { render, staticRenderFns } from "./Nodes.vue?vue&type=template&id=81027ca2&scoped=true"
import script from "./Nodes.vue?vue&type=script&lang=js"
export * from "./Nodes.vue?vue&type=script&lang=js"
import style0 from "./Nodes.vue?vue&type=style&index=0&id=81027ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81027ca2",
  null
  
)

export default component.exports